import React from 'react';

import PropTypes from 'prop-types';

import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'components/Dropdown2';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';

import sharedMessages from '../shared/SkuOrder.messages';

import messages from './SkuOrderDashboard.messages';
import { LIFECYCLE_STATUS, PARTNER_ORDERS_HISTORY_LIFECYCLE_FILTER_OPTIONS } from './SkuOrders.constants';
import './SkuOrderLifecycleStatusFilter.scss';

const { block, element } = bem('sku-order-lifecycle-status-filter');

const LIFECYCLE_STATUS_MESSAGES = {
  [LIFECYCLE_STATUS.FULFILLED]: sharedMessages.fulfilled,
  [LIFECYCLE_STATUS.CANCELLED]: messages.lifecycleStatusCancelled,
};

const SkuOrderLifecycleStatusFilter = ({ value, onChange }) => (
  <div className={block()}>
    <Dropdown attachment="left" className={element('dropdown')}>
      <DropdownToggle className={element('toggle', { placeholder: !value })}>
        {value ? (
          <Message message={LIFECYCLE_STATUS_MESSAGES[value]} />
        ) : (
          <Message message={messages.lifecycleStatusFilterLabel} />
        )}
      </DropdownToggle>
      <DropdownMenu className={element('menu')}>
        {PARTNER_ORDERS_HISTORY_LIFECYCLE_FILTER_OPTIONS.map(status => (
          <DropdownItem
            key={status}
            isSelected={status === value}
            onClick={() => onChange(status === value ? null : status)}>
            <Message message={LIFECYCLE_STATUS_MESSAGES[status]} />
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  </div>
);

SkuOrderLifecycleStatusFilter.propTypes = {
  value: PropTypes.oneOf([...PARTNER_ORDERS_HISTORY_LIFECYCLE_FILTER_OPTIONS, null]),
  onChange: PropTypes.func.isRequired,
};

export default SkuOrderLifecycleStatusFilter;
